import { render } from "./EmailVerificationComponent.vue?vue&type=template&id=b75890d4"
import script from "./EmailVerificationComponent.ts?vue&type=script&lang=js"
export * from "./EmailVerificationComponent.ts?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2514298771/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__